module.exports = __webpack_public_path__ + "static/8057-0a61ba362bd67ee896487c4bb51834be.jpg";